import Switcher from './Switcher';

export default Switcher;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Switcher/index.js